import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import OptimizersComparisonTaskEditDto from '../dto/OptimizersComparisonTaskEditDto';

class OptimizersComparisonTaskEditService {
    constructor() {
        this.connection = nBossConnection.connection;
        this.PARENT_CONTROL = 'taskManagerControl';
        this.CONTROL = 'optimizersComparisonTaskEditControl';
    }

    /**
     * @return {Promise<OptimizersComparisonTaskEditDto>}
     */
    create() {
        return new Promise((resolve, reject) => {
            this.connection
                .get(`/${this.CONTROL}/create`)
                .then(response => resolve(new OptimizersComparisonTaskEditDto().setup(response.data)))
                .catch(reject);
        });
    }

    /**
     * @param {string} type
     * @return {Promise<OptimizersComparisonTaskEditDto>}
     */
    createByType(type) {
        return new Promise((resolve, reject) => {
            this.connection
                .get(`/${this.CONTROL}/create`)
                .then(response => resolve(new OptimizersComparisonTaskEditDto().setup({ ...response.data, type })))
                .catch(reject);
        });
    }

    /**
     * @param {number} id
     * @return {Promise<OptimizersComparisonTaskEditDto>}
     */
    getData(id) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/getData`, {
                    id
                })
                .then(response => resolve(new OptimizersComparisonTaskEditDto().setup(response.data)))
                .catch(reject);
        });
    }

    /**
     * @param {OptimizersComparisonTaskEditDto} dto
     * @return {Promise<OcuEntityValidationResult>}
     */
    save(dto) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/save`, { dto })
                .then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
                .catch(reject);
        });
    }

    /**
     * @param {number} id
     * @param {OptimizersComparisonTaskEditDto} dto
     * @return {Promise<OcuEntityValidationResult>}
     */
    update(id, dto) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/update`, {
                    id,
                    dto
                })
                .then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
                .catch(reject);
        });
    }
}

export default new OptimizersComparisonTaskEditService();